// Case Files layout: the viewer is the right half of one unified container, so
// it drops the floating shadow/radius and squares off its left edge to meet the
// file list.
.joined {
    border: 1px solid #eaecf0;
    border-left: none;
    border-radius: 0 12px 12px 0;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06);
    overflow: hidden;
    background-color: #ffffff;
}

.markdownContent {
    padding-top: 35px;
    padding-left: 15px;
    padding-right: 15px;

    font-family: 'Hanken Grotesk', sans-serif;
    font-size: 14px;
    color: #102442;
    line-height: 1.6;
    overflow-x: auto;
    padding-bottom: 20px;

    table {
        width: 100%;
        border-collapse: collapse;
        margin: 12px 0;

        th {
            background-color: #243a5c;
            color: white;
            font-weight: 600;
            text-align: left;
            padding: 10px 14px;
            font-size: 13px;
            white-space: nowrap;
        }

        td {
            padding: 8px 14px;
            border-bottom: 1px solid #e9e0be;
            font-size: 13px;
            vertical-align: top;
        }

        tr:nth-child(even) {
            background-color: #f9f8f4;
        }

        tr:hover {
            background-color: #f0efe8;
        }
    }

    p {
        margin: 8px 0;
    }

    strong {
        font-weight: 600;
    }

    ul,
    ol {
        padding-left: 20px;
        margin: 8px 0;
    }

    li {
        margin-bottom: 4px;
    }
}
